import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bankSelect", "branchSelect"]

  connect() {
    this.updateBranches()
  }

  updateBranches() {
    const bankCode = this.bankSelectTarget.value
    console.log('Bank code selected:', bankCode)
    if (!bankCode) {
      this.clearBranches()
      return
    }

    console.log('Fetching branches for bank code:', bankCode)
    fetch(`/invitation/branches?bank_code=${bankCode}`)
      .then(response => {
        console.log('Response status:', response.status)
        return response.json()
      })
      .then(branches => {
        console.log('Branches received:', branches)
        this.populateBranches(branches)
      })
      .catch(error => {
        console.error('Error fetching branches:', error)
        this.clearBranches()
      })
  }

  clearBranches() {
    this.branchSelectTarget.innerHTML = '<option value="">支店を選択してください</option>'
  }

  populateBranches(branches) {
    this.branchSelectTarget.innerHTML = '<option value="">支店を選択してください</option>'
    branches.forEach(branch => {
      const option = document.createElement('option')
      option.value = branch.code
      option.textContent = branch.name
      this.branchSelectTarget.appendChild(option)
    })
  }
}